import moment from 'moment';

export const formatTimestamp = timestamp => moment.utc(timestamp).format('YYYY-MM-DD HH:mm:ss');

export const relativeTimestamp = timestamp => moment.utc(timestamp).fromNow();
